import { motion } from "framer-motion";
import { Phone, ChevronDown } from "lucide-react";
import { brand, images } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut", delay: i * 0.15 },
  }),
};

export const Hero = () => {
  const goTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Onoranze Funebri Bali"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#0A0A0A]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-2xl">
          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={0}
            className="text-sm tracking-[0.35em] uppercase text-[#D4AF37] mb-6"
          >
            Shërbime Funerale • që prej vitit {brand.founded}
          </motion.p>

          <motion.h1
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={1}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F5F5F5] leading-tight tracking-tight"
          >
            Bali <span className="text-[#D4AF37]">Funeral Home</span>
          </motion.h1>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={2}
            className="mt-6 text-lg text-gray-300 leading-relaxed max-w-xl"
          >
            {brand.tagline}
          </motion.p>

          <motion.div
            variants={fadeUp}
            initial="hidden"
            animate="show"
            custom={3}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <button
              data-testid="hero-cta-servizi"
              onClick={() => goTo("#servizi")}
              className="bg-[#D4AF37] text-black px-8 py-4 rounded-full text-sm tracking-wide font-medium hover:bg-[#B8962D] transition-colors duration-300"
            >
              Shërbimet Tona
            </button>
            <a
              data-testid="hero-call-btn"
              href={`tel:+${brand.whatsapp}`}
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-[#F5F5F5] px-8 py-4 rounded-full text-sm tracking-wide hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
            >
              <Phone size={16} strokeWidth={1.5} />
              {brand.phoneDisplay}
            </a>
          </motion.div>
        </div>
      </div>

      <button
        onClick={() => goTo("#servizi")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#D4AF37]/70 hover:text-[#D4AF37] transition-colors"
        aria-label="Lëviz poshtë"
      >
        <ChevronDown size={28} strokeWidth={1.5} className="animate-bounce" />
      </button>
    </section>
  );
};
